import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileResponseModel } from '../model/FileResponseModel';
import { QueryExecutorModel } from '../model/QueryExecutorModel';
import { QueryExecutorDetailModel } from '../model/QueryExecutorDetailModel';
import { Page } from '../model/Page';
import { BoardDocumentsModel } from '../model/BoardDocumentsModel';
import { BoardDocumentsResponseModel } from '../model/BoardDocumentsResponseModel';

@Injectable({
  providedIn: 'root'
})
export class BoardDocumentsService {

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  fetchBoardDocumentsList(page: number, size: number, filterText: string) {
    return this.httpClient.get<Page<BoardDocumentsModel>>(ApiUrls.boardDocumentsList + 
      `?page=${page}&size=${size}&filterText=${filterText}`);
  }

  initBoardDocumentsForm() {
    return this.httpClient.get<{
      boards: {[key: number]: string}, 
    }>(`${ApiUrls.initBoardDocumentsFormUrl}`);
  }

  getBoardDocumentBykey(key: number) {
    return this.httpClient.get<BoardDocumentsResponseModel>(`${ApiUrls.boardDocumentDetail.replace('{key}', key.toString())}`);
  }

  saveBoardDocument(data: {
    boardKey: number,
    headerLabelEn: string,
    headerLabelMr: string,
    displayOrder: number,
    fileType: string,
    urlEnBase64String: string | ArrayBuffer,
    urlMrBase64String: string | ArrayBuffer
  }) {
    return this.httpClient.post<{status: string, errorMessage: string}>(`${ApiUrls.saveBoardDocument}`, data); 
  }

  updateBoardDocument(key: number, data: {
    boardKey: number,
    headerLabelEn: string,
    headerLabelMr: string,
    displayOrder: number,
    fileType: string,
    urlEnBase64String: string | ArrayBuffer,
    urlMrBase64String: string | ArrayBuffer
  }) {
    return this.httpClient.put<{status: string, errorMessage: string}>(ApiUrls.updateBoardDocument.replace('{key}', key.toString()), data); 
  }

  toggleActivationBoardDocument(key: number, activeFlag: string) {
    return this.httpClient.patch<{status: string, errorMessage: string}>(ApiUrls.toggleActivationBoardDocumentUrl.replace('{key}', key.toString()), {
      activeFlag
    }); 
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
